import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getApiErrorMessage } from "@/modules/common/utils/apiError";
import { ADMIN_LEADS_ENDPOINTS, AdminLeadsService } from "@/service/api/admin-leads";
import { UpdateLeadDto } from "@/service/dto/admin-leads";

interface UpdateLeadParams {
  id: string;
  data: UpdateLeadDto;
}

const useUpdateLead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: UpdateLeadParams) => AdminLeadsService.update(id, data),
    onError: (error) => {
      toast.error(getApiErrorMessage(error, "Erro ao atualizar lead. Tente novamente mais tarde."), { toastId: "update_lead_error" });
    },
    // Retorna a promise para a mutação só concluir depois dos dados atualizados, evitando um piscar do valor antigo
    onSuccess: (_data, { id }) =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: [ADMIN_LEADS_ENDPOINTS.LIST] }),
        queryClient.invalidateQueries({ queryKey: [ADMIN_LEADS_ENDPOINTS.SUMMARY] }),
        queryClient.invalidateQueries({ queryKey: [ADMIN_LEADS_ENDPOINTS.DETAIL(id)], exact: true }),
      ]),
  });
};

export default useUpdateLead;
